import Vue from 'vue'
import Vant from 'vant'
import { Toast } from 'vant'
import App from './App.vue'
import store from './store'
import router from './router/router'
import globalMixin from './utils/mixin'
import globalRegister from './global'
import './utils/weixinPay'
import './utils/filter'
import './utils/catchError'
import 'vant/lib/index.css'
import 'swiper/swiper-bundle.css'
import 'flex.css/dist/data-flex.css'
import '@/assets/css/shop.scss'
// import '@/assets/css/global-mixin.scss'
import '@/assets/css/common.css'
import '@/assets/css/empower.css'
import '@/assets/css/index.scss'
import { getEnv, getParams, formatTime } from './utils/utils.js'
import { useRem } from './utils/rem'
import VzanUpload from '@/utils/vzanUpload.js'
import NP from 'number-precision'
import YeepayKeyboard from '@yeepay/virtual-keyboard'
import '@yeepay/virtual-keyboard/dist/index.css'
useRem()
Vue.config.devtools = true
Vue.use(Vant)
Vue.use(globalRegister)
Vue.use(YeepayKeyboard)
Vue.prototype.$toast.setDefaultOptions({
  duration: 3000,
})
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'

import moment from 'moment'
moment.locale('zh-cn')
window.moment = moment

Vue.prototype.$np = NP
window.$np = NP
const { zbid, zid, zbId } = getParams()
const liveid = zbid || zid || zbId
Vue.prototype.$upload = new VzanUpload(liveid)
Vue.prototype.$formatTime = formatTime
Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
  'wx-open-subscribe',
  'wx-open-launch-app',
]
Vue.prototype.$bus = new Vue()
Vue.use(VueAwesomeSwiper)
Vue.mixin(globalMixin)

// 自定义组件
import vzanAddress from './components/vzan-address'
import vzanSubscribe from './components/vzan-subscribe'
import ProbackToLive from './components/ProbackToLive/index.vue'
import ProbackToTrain from './components/ProbackToLive/ProbackToTrain.vue'
import QrCode from './components/global/QrCode.vue'
import RichText from './components/global/RichText.vue'
import VzButton from './components/VzButton/index.vue'
import vzanAddressNew from './components/vzan-address-new'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
Vue.use(vzanAddress)
Vue.use(vzanSubscribe)
Vue.component('ProbackToLive', ProbackToLive)
Vue.component('ProbackToTrain', ProbackToTrain)
Vue.component('QrCode', QrCode)
Vue.component('RichText', RichText)
Vue.component('VzButton', VzButton)
Vue.use(vzanAddressNew)
import '@vant/touch-emulator'
// 自定义指令
let loading_el
Vue.directive('loading', {
  inserted(el, binding) {
    const isFull = binding.modifiers.full
    loading_el = document.createElement('div')
    loading_el.setAttribute(
      'style',
      `width:100%;
      height:100%;
      position:absolute;
      top:0;
      left:0;
      right:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      background:rgba(255,255,255,0.95);
      z-index:${isFull ? '9999' : 'unset'}
      `
    )

    loading_el.innerHTML = `<div class="van-loading van-loading--circular"><span data-v-1f789101="" class="van-loading__spinner van-loading__spinner--circular"><svg data-v-1f789101="" viewBox="25 25 50 50" class="van-loading__circular"><circle data-v-1f789101="" cx="50" cy="50" r="20" fill="none"></circle></svg></span></div>`
    el.appendChild(loading_el)
  },
  update(el, binding) {
    let inline_style = loading_el.getAttribute('style') || ''
    inline_style = binding.value
      ? inline_style.replace('display:none', 'display:flex')
      : inline_style.replace('display:flex', 'display:none')
    loading_el.setAttribute('style', inline_style)
  },
  unbind() {
    loading_el && loading_el.remove()
  },
})

Vue.directive('copy', {
  /*
  bind 钩子函数，第一次绑定时调用，可以在这里做初始化设置
  el: 作用的 dom 对象
  value: 传给指令的值，也就是我们要 copy 的值
*/
  bind(el, { value, arg }) {
    el.$value = value // 用一个全局属性来存传进来的值，因为这个值在别的钩子函数里还会用到
    el.handler = () => {
      if (arg === 'allowEmpty' && value === '') {
        el.$value = ' '
      }
      if (!el.$value) {
        // 值为空的时候，给出提示
        Toast('复制失败')
        return
      }
      // 动态创建 textarea 标签
      const textarea = document.createElement('textarea')
      // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
      textarea.readOnly = 'readonly'
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      // 将要 copy 的值赋给 textarea 标签的 value 属性
      textarea.value = el.$value
      // 将 textarea 插入到 body 中
      document.body.appendChild(textarea)
      // 选中值并复制
      textarea.select()
      // textarea.setSelectionRange(0, textarea.value.length);
      const result = document.execCommand('Copy')
      if (result) {
        Toast('复制成功')
      }
      document.body.removeChild(textarea)
    }
    // 绑定点击事件，就是所谓的一键 copy 啦
    el.addEventListener('click', el.handler)
  },
  // 当传进来的值更新的时候触发
  componentUpdated(el, { value }) {
    el.$value = value
  },
  // 指令与元素解绑的时候，移除事件绑定
  unbind(el) {
    el.removeEventListener('click', el.handler)
  },
})
// window.$.cookie('zbvz_userid', '2E25E8C518183176')
// 接入apm
// eslint-disable-next-line no-constant-condition
if (process.env.NODE_ENV !== 'dev') {
  Vue.use(ApmVuePlugin, {
    router,
    config: {
      serviceName: 'vzanlivemobile',
      serverUrl: 'https://es-apm.vzan.com',
      serviceVersion: '1.0',
      environment: getEnv(),
      transactionSampleRate: 0.1,
    },
  })
}

const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
window.vzanLiveApp = app
